import * as Yup from 'yup';

import {
    ProductCategory,
    ProductSubtype,
    ProductType,
} from '@barboxx/models/types';
import { MEDIUM_TEXT, MINIMUM_TEXT, TINY_TEXT } from '@barboxx/types';
import { transformEmptyToNull } from '@barboxx/utils';

export const ALCOHOL_CATEGORY_SCHEMA: Yup.ObjectSchema<ProductCategory.Base> =
    Yup.object().shape({
        id: Yup.number().required(),
        name: Yup.string()
            .required()
            .min(MINIMUM_TEXT, 'Too Short!')
            .max(TINY_TEXT, 'Too Long!'),
        description: Yup.string()
            .nullable()
            .transform(transformEmptyToNull)
            .default(null)
            .min(MINIMUM_TEXT, 'Too Short!')
            .max(MEDIUM_TEXT, 'Too Long!'),
    });

export const CREATE_ALCOHOL_CATEGORY_SCHEMA = ALCOHOL_CATEGORY_SCHEMA.omit([
    'id',
]);

export const ALCOHOL_TYPE_SCHEMA = Yup.object<ProductType.Base>().shape({
    id: Yup.number().required(),
    productCategoryId: Yup.number().required(),
    name: Yup.string().required('Required'),
    description: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    abvRange: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    productionMethod: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    isAlcoholic: Yup.boolean().default(true),
});

export const CREATE_ALCOHOL_TYPE_SCHEMA = ALCOHOL_TYPE_SCHEMA.omit(['id']);

export const ALCOHOL_SUBTYPE_SCHEMA = Yup.object<ProductSubtype.Base>().shape({
    id: Yup.number().required(),
    name: Yup.string().required('Required'),
    description: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    productTypeId: Yup.number().required(),
    agingRequirements: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    regionalRequirements: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    otherSpecifications: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    isAlcoholic: Yup.boolean().default(true),
});
export const CREATE_ALCOHOL_SUBTYPE_SCHEMA = ALCOHOL_SUBTYPE_SCHEMA.omit([
    'id',
]);
